module.exports = __webpack_public_path__ + "img/advantage11.16af5654.png";